module.exports = "body {\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fsapplication/preset/preset.component.css
// module id = ./src/app/fsapplication/preset/preset.component.css
// module chunks = main